export const useStrategy = () => {
  const { t } = useI18n()
  const prioritiesEnvironmental = [
    {
      c1: t('strategy.priorities.tableDataE.item1.c1'),
      c2: t('strategy.priorities.tableDataE.item1.c2'),
      c3: t('strategy.priorities.tableDataE.item1.c3'),
    },
  ]

  const prioritiesSocial = [
    {
      c1: t('strategy.priorities.tableDataS.item1.c1'),
      c2: t('strategy.priorities.tableDataS.item1.c2'),
      c3: t('strategy.priorities.tableDataS.item1.c3'),
    },
    {
      c1: t('strategy.priorities.tableDataS.item2.c1'),
      c2: t('strategy.priorities.tableDataS.item2.c2'),
      c3: t('strategy.priorities.tableDataS.item2.c3'),
    },
    {
      c1: t('strategy.priorities.tableDataS.item3.c1'),
      c2: t('strategy.priorities.tableDataS.item3.c2'),
      c3: t('strategy.priorities.tableDataS.item3.c3'),
    },
  ]

  const prioritiesGovernance = [
    {
      c1: t('strategy.priorities.tableDataG.item1.c1'),
      c2: t('strategy.priorities.tableDataG.item1.c2'),
      c3: t('strategy.priorities.tableDataG.item1.c3'),
    },
  ]

  const committeeList = [
    {
      item: t('strategy.committee.list.item1'),
    },
    {
      item: t('strategy.committee.list.item2'),
    },
    {
      item: t('strategy.committee.list.item3'),
    },
    {
      item: t('strategy.committee.list.item4'),
    },
    {
      item: t('strategy.committee.list.item5'),
    },
    {
      item: t('strategy.committee.list.item6'),
    },
    {
      item: t('strategy.committee.list.item7'),
    },
    {
      item: t('strategy.committee.list.item8'),
    },
  ]

  const keyPoliciesTabs = [
    {
      label: t('strategy.keyPolicies.e.tab'),
      slotName: 'environmental',
      content: {
        legend: {
          items: [
            {
              text: t('strategy.keyPolicies.e.legend.text1'),
              color: '#EEF9FF',
            },
            {
              text: t('strategy.keyPolicies.e.legend.text2'),
              color: '#2F6B8C',
            },
            {
              text: t('strategy.keyPolicies.e.legend.text3'),
              color: '#3B85AF',
            },
            {
              text: t('strategy.keyPolicies.e.legend.text4'),
              color: '#47A0D2',
            },
          ],
        },
      },
    },
    {
      label: t('strategy.keyPolicies.s.tab'),
      slotName: 'social',
      content: {
        legend: {
          items: [
            {
              icon: '/images/flag-poland.png',
              text: t('strategy.keyPolicies.s.legend.text2'),
              score: '1344',
            },
            {
              icon: '/images/flag-czech.png',
              text: t('strategy.keyPolicies.s.legend.text3'),
              score: '797',
            },
            {
              icon: '/images/flag-slovakia.png',
              text: t('strategy.keyPolicies.s.legend.text5'),
              score: '197',
            },
            {
              icon: '/images/flag-bulgaria.png',
              text: t('strategy.keyPolicies.s.legend.text4'),
              score: '348',
            },
            {
              icon: '/images/flag-croatia.png',
              text: t('strategy.keyPolicies.s.legend.text7'),
              score: '179',
            },
            {
              icon: '/images/flag-turkey.png',
              text: t('strategy.keyPolicies.s.legend.text6'),
              score: '1331',
            },
          ],
        },
      },
    },
    {
      label: t('strategy.keyPolicies.g.tab'),
      slotName: 'governance',
      content: {
        legend: [
          {
            items: [
              {
                text: t('strategy.keyPolicies.g.legend.text2'),
              },
              {
                text: t('strategy.keyPolicies.g.legend.text3'),
              },
            ],
          },
          {
            items: [
              {
                text: t('strategy.keyPolicies.g.legend.text4'),
              },
              {
                text: t('strategy.keyPolicies.g.legend.text5'),
              },
            ],
          },
          {
            items: [
              {
                text: t('strategy.keyPolicies.g.legend.text6'),
              },
              {
                text: t('strategy.keyPolicies.g.legend.text7'),
              },
            ],
          },
        ],
      },
    },
  ]

  return {
    prioritiesEnvironmental,
    prioritiesSocial,
    prioritiesGovernance,
    committeeList,
    keyPoliciesTabs,
  }
}
